function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15,9 L15,14 L10,14 L10,12 L13,12 L13,9 L15,9 Z M15,2 L15,7 L13,7 L13,4 L10,4 L10,2 L15,2 Z M3,12 L6,12 L6,14 L1,14 L1,9 L3,9 L3,12 Z M3,4 L3,7 L1,7 L1,2 L6,2 L6,4 L3,4 Z"
});
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.d165e97b1641b1691e383b8946a947b7.svg";
export { ForwardRef as ReactComponent };